import lockupUrl from "@enrein/design-system/assets/enrein-lockup-horizontal.svg";

export function EnreinBrandBlock() {
  return (
    <div className="enrein-brand-block" aria-label="Enrein">
      <img
        src={lockupUrl}
        alt="Enrein"
        className="enrein-brand-block__lockup"
        width={160}
        height={34}
      />
    </div>
  );
}
